import { normalizeNumber } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_CREAM_CHIP_IN_VALUES = createFcmConfig('cream_chip_in_values', {
	normalizer: normalizeNumber,
	defaultValue: undefined,
});
